/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  TicketRepresentation,
} from '../models/index';
import {
    TicketRepresentationFromJSON,
    TicketRepresentationToJSON,
} from '../models/index';

export interface GetAsyncTicketRequest {
    ticketId: string;
}

/**
 * 
 */
export class AsyncTicketsApi extends runtime.BaseAPI {

    /**
     * Returns the current status, progress and result (when done) of an async job ticket
     * Get async ticket status and result
     */
    async getAsyncTicketRaw(requestParameters: GetAsyncTicketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TicketRepresentation>> {
        if (requestParameters['ticketId'] == null) {
            throw new runtime.RequiredError(
                'ticketId',
                'Required parameter "ticketId" was null or undefined when calling getAsyncTicket().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["data:read"]);
        }


        let urlPath = `/async-tickets/{ticketId}`;
        urlPath = urlPath.replace(`{${"ticketId"}}`, encodeURIComponent(String(requestParameters['ticketId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TicketRepresentationFromJSON(jsonValue));
    }

    /**
     * Returns the current status, progress and result (when done) of an async job ticket
     * Get async ticket status and result
     */
    async getAsyncTicket(ticketId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TicketRepresentation> {
        const response = await this.getAsyncTicketRaw({ ticketId: ticketId }, initOverrides);
        return await response.value();
    }

}
